import * as React from 'react';

import { cn } from '@blockworks/ui/utils';

import PriceSponsoredBy from '@/components/pages/price/components/header/price-sponsored-by';

type PriceHeadProps = {
    sponsoredBy: JSX.Element | React.ReactNode | string | null;
    title?: string;
    className?: string;
};

const PriceHead = (props: PriceHeadProps) => {
    const { className, sponsoredBy, title } = props;

    return (
        <section
            className={cn(
                'flex justify-between items-center self-stretch h-[60px] px-6 lg:px-10 py-5 border-t border-b',
                className,
            )}
        >
            <div className="flex justify-start items-center gap-3">
                <div className="flex flex-col justify-start items-start gap-2.5">
                    <div className="flex justify-start items-center relative">
                        <p className="text-base text-left uppercase text-dark">{title ?? 'price'}</p>
                    </div>
                </div>
            </div>
            <PriceSponsoredBy title="sponsored by">{sponsoredBy}</PriceSponsoredBy>
        </section>
    );
};

export default PriceHead;
